/* import axios from 'axios' */
import {
    axiosJwt
} from '@/shared/auth/axios-lib'
import {
    errorHandler
} from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterAnosCalendario() {
        let url = `${api}/dirfs/anoscalendario`
        return axiosJwt.get(url)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterDirf(ano) {
        let url = `${api}/fornecedor/dirf/${ano}`
        return axiosJwt.get(url)
            .then((response) => {
                return response.data
            }).catch((error) => {
                return errorHandler(error)
            })
    },

    obterRendimentos(id) {
        let url = `${api}/fornecedor/dirf/${id}/rendimentos`
        return axiosJwt.get(url, {
            responseType: 'blob'
        }).then((response) => {
            return response.data
        }).catch((error) => {
            return errorHandler(error)
        })
    },

    obterPagamentos(id) {
        let url = `${api}/fornecedor/dirf/${id}/pagamentos`
        return axiosJwt.get(url, {
            responseType: 'blob'
        }).then((response) => {
            return response.data
        }).catch((error) => {
            return errorHandler(error)
        })
    }
}
